import { Injectable } from '@angular/core';
import { tJWT, JwtService } from './jwt.service';
import { DialogService } from './dialog.service';
import { HttpService } from './http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GoogleRecaptchaService } from './google-recaptcha.service';

@Injectable({
  providedIn: 'root'
})
export class SudoModeService {
  private jwt: tJWT;

  constructor(
    private dialog: DialogService,
    private http: HttpService,
    private jwtService: JwtService,
    private recaptcha: GoogleRecaptchaService
  ) {}

  public async get() {
    if (this.jwt && this.jwt.valid()) return this.jwt.jwt;
    return this.initSudoMode();
  }

  public remove() {
    this.jwt = null;
  }

  private async initSudoMode(): Promise<string | false> {
    if (this.jwt && this.jwt.valid()) return this.jwt.jwt;

    const password = await this.promptPasswordRequest();
    if (!password || !(password[0].value as string).length) return false;

    const httpRes = await this.getSudoJWT(password[0].value as string);
    if (!httpRes) return false;

    const jwt = await this.decodeJWT(httpRes);
    if (!jwt) return false;

    this.jwt = jwt;
    return this.initSudoMode();
  }

  private promptPasswordRequest() {
    return this.dialog.prompt(
      'הזדהות מחדש',
      {
        type: 'password',
        label: 'סיסמה',
        required: true
      },
      'הנכם מנסים לבצע פעולה רגישה הדורשת הזדהות מחודשת. אנא הזינו בתיבה מתחת את הסיסמה למשתמש שלכם. לאחר מכן, לתקופה של כ-10 דקות, לא תצטרכו להזדהות מחדש.',
      'הזדהות'
    );
  }

  private async getSudoJWT(password: string) {
    const recaptcha = await this.recaptcha.getToken('sudo').catch(e => this.http.alertError(e));
    if (!recaptcha) return false;

    return this.http
      .post<{ sudoToken: string }>('Authentication', ['token', 'sudo'], { password, recaptcha }, true)
      .then(r => r.sudoToken)
      .catch(err => this.decodeHttpError(err));
  }

  private async decodeHttpError(error: HttpErrorResponse) {
    const err = this.http.decodeError(error, {
      USERNAME_OR_PASSWORD_INCORRECT: 'הסיסמה שהוזנה שגויה. יש לנסות שנית.'
    });

    await this.dialog.alert('שגיאה', err.msg);

    if (err.msg == 'הסיסמה שהוזנה שגויה. יש לנסות שנית.') return this.initSudoMode();
    return false;
  }

  private async decodeJWT(jwt: string) {
    const jwtId = await this.jwtService.addJWT(jwt, { num: 1, type: 's' }).catch(e => console.error(e));
    if (!jwtId && jwtId !== 0) return false;

    return this.jwtService.getJWT(jwtId);
  }
}
